import Request from "../../shared/utils/_request";
import sse from "@/app/admin/system/ai/sse";
class aiAssistantApi {
    constructor() {}
    generate(type,params,callback){
        let url = "/aibiz/ie/assistant/postJob/generateContent";
        if (type == "3"){
            url = "/aibiz/ie/assistant/appraise/generateContent";
        }
       return sse.fetchsse(url, undefined, undefined, callback, params);
    }

    // postJobGenerateContent(payload) {
    //     return Request.http("/aibiz/ie/assistant/postJob/generateContent", payload,'java');
    // }
}
export const api = new aiAssistantApi();
